import {LoginViaPRCComponent} from './components/login-via-prc.component.ts/login-via-prc.component';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BnDatepickerComponent, bnDatepickerProviders} from '@bndes/bndes-ux4/bn-datepicker';
import { BndesUx4 } from "@bndes/bndes-ux4/base";
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import { BnOrdenacaoComponent } from '@bndes/bndes-ux4/bn-ordenacao';
import { BnCnpjPipe } from '@bndes/bndes-ux4/pipes/cnpj';
import { BnValorPorExtensoPipe } from '@bndes/bndes-ux4/pipes/valor-por-extenso'
import { BnMaskPipe } from "@bndes/bndes-ux4/bn-mask/bn-mask-pipe";
import { BnMaskDirective } from "@bndes/bndes-ux4/bn-mask/bn-mask-directive";
import { BnPaginacaoComponent } from '@bndes/bndes-ux4/bn-paginacao';
import { BnAutocompleteAreaGeograficaComponent } from '@bndes/bndes-ux4/bn-autocomplete-area-geografica';
import { BnAutocompleteCnaeComponent } from '@bndes/bndes-ux4/bn-autocomplete-cnae';
import { BnNavComponent } from '@bndes/bndes-ux4/bn-nav';
import { BnHeaderComponent} from '@bndes/bndes-ux4/bn-header';
import { BnContainerComponent} from '@bndes/bndes-ux4/bn-container';
import { BnAlertsComponent } from '@bndes/bndes-ux4/bn-alerts';
import { BnLoadingOverlayComponent } from '@bndes/bndes-ux4/bn-loading-overlay';


// Componentes do PAJ
import {PesquisaPacComponent} from './components/pesquisa-pac/pesquisa-pac.component';
import {AnalisaAditivoComponent} from './components/analisa-aditivo/analisa-aditivo.component';
import {DetalheDiferencaComponent} from './components/detalhe-diferenca/detalhe-diferenca.component';
import {EnvioAditivoComponent} from './components/envio-aditivo/envio-aditivo.component';
import { PesquisaAditivoComponent } from './components/pesquisa-aditivo/pesquisa-aditivo.component';
import { PesquisaInternaAditivoComponent } from './components/pesquisa-interna-aditivo/pesquisa-interna-aditivo.component';
import { ConsultaAditivoComponent } from './components/consulta-aditivo/consulta-aditivo.component';
import { HomeComponent } from './components/home/home.component';
import { PesquisaPropostaComponent } from './components/pesquisa-proposta/pesquisa-proposta.component';
import { InformacoesGeraisOperacaoComponent } from './components/exibicao-proposta/informacoes-gerais-operacao/informacoes-gerais-operacao.component';
import { InformacoesDaCompradoraComponent } from './components/exibicao-proposta/informacoes-da-compradora/informacoes-da-compradora.component';
import { DetalheDaPropostaComponent } from './components/exibicao-proposta/detalhe-da-proposta/detalhe-da-proposta.component';
import { InformacoesDaFabricanteComponent } from './components/exibicao-proposta/informacoes-da-fabricante/informacoes-da-fabricante.component';
import { InformacoesDoInvestimentoComponent } from './components/exibicao-proposta/informacoes-do-investimento/informacoes-do-investimento.component';
import { InformacoesDaOperacaoEGarantiasComponent } from './components/exibicao-proposta/informacoes-da-operacao-e-garantias/informacoes-da-operacao-e-garantias.component';
import { InformacoesEquipamentosComponent } from './components/exibicao-proposta/informacoes-equipamentos/informacoes-equipamentos.component';
import { InformacoesPedidosLiberacaoComponent } from './components/exibicao-proposta/informacoes-pedidos-liberacao/informacoes-pedidos-liberacao.component';
import {PacFormat} from './pipes/pacFormat';

import { AnaliseCondicionadasComponent } from './components/exibicao-proposta/analise-condicionadas/analise-condicionadas.component';

import { InformacoesDosAnexosComponent } from './components/exibicao-proposta/informacoes-dos-anexos/informacoes-dos-anexos.component';
import { InformacoesDeAditivosComponent } from './components/exibicao-proposta/informacoes-de-aditivos/informacoes-de-aditivos.component';
import { InformacoesDeCancelamentoDoSaldoComponent } from './components/exibicao-proposta/informacoes-de-cancelamento-do-saldo/informacoes-de-cancelamento-do-saldo.component';
import { InformacoesDoHistoricoComponent } from './components/exibicao-proposta/informacoes-do-historico/informacoes-do-historico.component';
import { BnHttpModule } from "@bndes/bndes-ux4/bndes-angular-utils";


@NgModule({ declarations: [
        PacFormat,
        AppComponent,
        LoginViaPRCComponent,
        HomeComponent,
        PesquisaInternaAditivoComponent,
        AnalisaAditivoComponent,
        DetalheDiferencaComponent,
        PesquisaPacComponent,
        EnvioAditivoComponent,
        PesquisaAditivoComponent,
        ConsultaAditivoComponent,
        PesquisaPropostaComponent,
        ConsultaAditivoComponent,
        InformacoesGeraisOperacaoComponent,
        InformacoesDaCompradoraComponent,
        DetalheDaPropostaComponent,
        InformacoesDaFabricanteComponent,
        InformacoesDoInvestimentoComponent,
        InformacoesDaOperacaoEGarantiasComponent,
        InformacoesEquipamentosComponent,
        InformacoesPedidosLiberacaoComponent,
        AnaliseCondicionadasComponent,
        InformacoesDosAnexosComponent,
        InformacoesDeAditivosComponent,
        InformacoesDeCancelamentoDoSaldoComponent,
        InformacoesDoHistoricoComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        HttpClientModule,
        BndesUx4.forRoot({
            baseUrl: '.',
            externalLogoutUrl: 'rest/seguro/logout'
        }),
        FormsModule,
        BnHttpModule.forRoot({useCache: true}),
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        BnOrdenacaoComponent,
        BnMaskPipe,
        BnMaskDirective,
        BnCnpjPipe,
        BnValorPorExtensoPipe,
        BnPaginacaoComponent,
        BnAutocompleteAreaGeograficaComponent,
        BnAutocompleteCnaeComponent,
        BnNavComponent,
        BnHeaderComponent,
        BnContainerComponent,
        BnAlertsComponent,
        BnLoadingOverlayComponent,
        BnDatepickerComponent 
    ],
    exports: [
        BnOrdenacaoComponent,
        BnMaskPipe,
        BnValorPorExtensoPipe,
        BnMaskDirective,
        BnCnpjPipe,
        BnPaginacaoComponent,
        BnAutocompleteAreaGeograficaComponent,
        BnAutocompleteCnaeComponent,
        BnNavComponent,
        BnHeaderComponent,
        BnContainerComponent,
        BnAlertsComponent,
        BnLoadingOverlayComponent,
        BnDatepickerComponent 
    ],
    providers: [
        bnDatepickerProviders,
//      provideHttpClient(withInterceptorsFromDi()) // não funciona mais no BNDES-UX4 / angular 18
    ] })
export class AppModule {
}
